module.exports = __webpack_public_path__ + "img/img_30.d7e773f0.png";